import { ChangeDetectionStrategy, Component, computed } from '@angular/core';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { TranslocoPipe } from '@jsverse/transloco';

import { BaseColumnComponent } from '~components/dynamic-table/column-components/base-column.component';
import { ButtonColumnModel } from '~components/dynamic-table/models/column-types/button-column.model';
import { Identifyable } from '~core/abstractions/identifyable';
import { ButtonComponent } from '../../../button/button.component';

@Component({
    selector: 'arc-button-column',
    templateUrl: './button-column.component.html',
    changeDetection: ChangeDetectionStrategy.Default,
    imports: [ButtonComponent, MatIconButton, MatIcon, MatButton, TranslocoPipe]
})
export class ButtonColumnComponent<T extends Identifyable<TId>, TId = number> extends BaseColumnComponent<T, TId> {
    isLoading = computed(() => !!this.buttonColumnModel.isLoading && this.buttonColumnModel.isLoading(this.item)());
    get buttonColumnModel(): ButtonColumnModel<T> {
        return this.columnModel as ButtonColumnModel<T>;
    }
    get isDisabled(): boolean {
        return !!this.buttonColumnModel.isButtonDisabled ? this.buttonColumnModel.isButtonDisabled(this.item) : false;
    }

    onClick(): void {
        this.buttonColumnModel.onClickFunction(this.item, this.formGroup);
    }
}
